const AiContentGeneratorFeedback = () => {
  return (
    <>
      <div className="ail-feedback-area ptb-120">
        <div className="container">
          <div className="row">
            <div className="col-xxl-6 col-xl-8 col-lg-10">
              <p className="ail-sub-title text-black fw-500 ah-input-bg d-inline-flex align-items-center gap-2 rounded-5 mb-20">
                <span className="ail-gd-bg"></span>Testimonial
              </p>
              <h2 className="ail-title text-black fs-48 fw-600 mb-20">
                What amazing content will you{" "}
                <span className="ail-highlighted-text">create with AI</span>?
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4">
              <div className="aih-testimonial-item bgc-white p-4 rounded-16 mt-20">
                <ul className="list-unstyled d-flex align-items-center gap-2">
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                </ul>
                <h6 className="text-black fs-18 mb-20">
                  Most recently I wrote my first
                </h6>
                <p className="ca-two-body-clr mb-20">
                  “You don’t have to be constantly searching the web to get
                  price updates.”
                </p>
                <div className="d-flex align-items-center gap-3">
                  <img
                    src="assets/img/software-company/client-md-3.png"
                    alt=""
                  />
                  <div className="ail-content">
                    <h6 className="aih-color-two fs-20 fw-600 mb-0">
                      Logan jon deo
                    </h6>
                    <p className="ca-two-body-clr fs-14 ff-dmsans mb-0">
                      Director at Webflow{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="aih-testimonial-item bgc-white p-4 rounded-16 mt-20">
                <ul className="list-unstyled d-flex align-items-center gap-2">
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                </ul>
                <h6 className="text-black fs-18 mb-20">
                  Probably the best platform
                </h6>
                <p className="ca-two-body-clr mb-20">
                  “You don’t have to be constantly searching the web to get
                  price updates. Just use our coin calculator and simply get the
                  desired result with a simple click. Super helpful with writing
                  my copies, allows me to complete my monthly social calendar in
                  an hour!”
                </p>
                <div className="d-flex align-items-center gap-3">
                  <img
                    src="assets/img/software-company/client-md-1.png"
                    alt=""
                  />
                  <div className="ail-content">
                    <h6 className="aih-color-two fs-20 fw-600 mb-0">
                      Logan jon deo
                    </h6>
                    <p className="ca-two-body-clr fs-14 ff-dmsans mb-0">
                      Director at Webflow{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4">
              <div className="aih-testimonial-item bgc-white p-4 rounded-16 mt-20">
                <ul className="list-unstyled d-flex align-items-center gap-2">
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                </ul>
                <h6 className="text-black fs-18 mb-20">
                  Probably the best platform
                </h6>
                <p className="ca-two-body-clr mb-20">
                  “You don’t have to be constantly searching the web to get
                  price updates. Just use our coin calculator and simply get the
                  desired result with a simple click. Super helpful with writing
                  my copies, allows me to complete my monthly social calendar in
                  an hour!”
                </p>
                <div className="d-flex align-items-center gap-3">
                  <img
                    src="assets/img/software-company/client-md-2.png"
                    alt=""
                  />
                  <div className="ail-content">
                    <h6 className="aih-color-two fs-20 fw-600 mb-0">
                      Logan jon deo
                    </h6>
                    <p className="ca-two-body-clr fs-14 ff-dmsans mb-0">
                      Director at Webflow{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="aih-testimonial-item bgc-white p-4 rounded-16 mt-20">
                <ul className="list-unstyled d-flex align-items-center gap-2">
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                </ul>
                <h6 className="text-black fs-18 mb-20">
                  Most recently I wrote my first
                </h6>
                <p className="ca-two-body-clr mb-20">
                  “You don’t have to be constantly searching the web to get
                  price updates.”
                </p>
                <div className="d-flex align-items-center gap-3">
                  <img
                    src="assets/img/software-company/client-md-3.png"
                    alt=""
                  />
                  <div className="ail-content">
                    <h6 className="aih-color-two fs-20 fw-600 mb-0">
                      Logan jon deo
                    </h6>
                    <p className="ca-two-body-clr fs-14 ff-dmsans mb-0">
                      Director at Webflow{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4">
              <div className="aih-testimonial-item bgc-white p-4 rounded-16 mt-20">
                <ul className="list-unstyled d-flex align-items-center gap-2">
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                </ul>
                <h6 className="text-black fs-18 mb-20">
                  Most recently I wrote my first
                </h6>
                <p className="ca-two-body-clr mb-20">
                  “You don’t have to be constantly searching the web to get
                  price updates. Just use our coin calculator and simply get the
                  desired result with a simple click. ”{" "}
                </p>
                <div className="d-flex align-items-center gap-3">
                  <img
                    src="assets/img/software-company/client-md-1.png"
                    alt=""
                  />
                  <div className="ail-content">
                    <h6 className="aih-color-two fs-20 fw-600 mb-0">
                      Logan jon deo
                    </h6>
                    <p className="ca-two-body-clr fs-14 ff-dmsans mb-0">
                      Director at Webflow{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="aih-testimonial-item bgc-white p-4 rounded-16 mt-20">
                <ul className="list-unstyled d-flex align-items-center gap-2">
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                  <li className="aih-color-four">
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </li>
                </ul>
                <h6 className="text-black fs-18 mb-20">
                  Most recently I wrote my first
                </h6>
                <p className="ca-two-body-clr mb-20">
                  “You don’t have to be constantly searching the web to get
                  price updates. Just use our coin calculator and simply get the
                  desired result with a simple click. ”{" "}
                </p>
                <div className="d-flex align-items-center gap-3">
                  <img
                    src="assets/img/software-company/client-md-2.png"
                    alt=""
                  />
                  <div className="ail-content">
                    <h6 className="aih-color-two fs-20 fw-600 mb-0">
                      Logan jon deo
                    </h6>
                    <p className="ca-two-body-clr fs-14 ff-dmsans mb-0">
                      Director at Webflow{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AiContentGeneratorFeedback;
